import { FC } from "react";

import { cn } from "@/lib/utils";
import { useUser } from "modules/user/useUser/useUser";

import { replacePersonaPlaceholders } from "../adonis.helpers";
import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";
import { AdvisorAvatar } from "../AdvisorAvatar/AdvisorAvatar";
import carouselPlaceholder from "../assets/carousel-placeholder.webp";

import { AdvisorMissingOutCard } from "./AdvisorMissingOutCard";

export interface AdvisorMissingOutCarouselProps {
  onButtonClick: () => void;
  buttonColor?: string;
  className?: string;
  headerText?: string;
}

export const AdvisorMissingOutCarousel: FC<AdvisorMissingOutCarouselProps> = ({
  onButtonClick,
  buttonColor,
  className,
  headerText,
}) => {
  const { persona } = useAdonisChat();
  const { user } = useUser();

  const username = user?.firstName ?? "";
  const defaultHeaderText = "Recommended<br> for {username}...";

  const text = replacePersonaPlaceholders(
    (headerText || defaultHeaderText).replace("{username}", username),
    persona
  );

  return (
    <div
      className={cn("relative w-full overflow-hidden", className)}
      style={{
        background:
          "radial-gradient(ellipse at 10% 25%, rgba(255, 255, 255, 0.9) 0%, rgba(238, 218, 197, 0.8) 70%, rgba(222, 193, 156, 0.6) 100%)",
      }}
    >
      <div className="relative flex flex-col gap-4 py-10">
        <div className="flex items-center justify-center gap-6">
          <AdvisorAvatar advisor={persona.name} size="large" />
          <span
            className="mt-2 text-left font-serif text-[27px] italic leading-tight"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>

        <div
          className="my-4 flex min-h-[360px] w-full items-center justify-center bg-cover bg-center bg-no-repeat px-8"
          style={{
            backgroundImage: `url(${carouselPlaceholder})`,
          }}
        >
          <div className="shadow-lg">
            <AdvisorMissingOutCard
              buttonColor={buttonColor}
              onButtonClick={onButtonClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
